import React from 'react';
import useEventListener from 'hooks/use-event-listener';
import { throttle } from 'lodash';

export default function useWindowDimensions(): {
  width: number;
  height: number;
} {
  const [{ width, height }, setSize] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEventListener(
    'resize',
    throttle(() => {
      setSize({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 1000),
    window,
  );

  return { width, height };
}
